import Validation from './alpine-validation';

export default (apiRoute) => ({

    firstName: '',
    lastName: '',
    email: '',
    street: '',
    city: '',
    postalCode: null,
    appointment: null,
    appointmentSet: false,
    phone: null,
    phoneError: false,
    dealers: [],
    dealer: [],
    dealerError: false,
    showBottledWater: false,
    bottledWater: false,
    comments: '',
    formError: false,     
    apiRoute: apiRoute,
    attemptSubmit: false,
    submitStatus: '',
    
    //validation
    validation: Validation,

    //required fields
    requiredFields: {
        firstName: true,
        lastName: true,
        email: true,
        street: true,
        city: true,
        postalCode: true,
        phone: true,
    },

    init(){
        this.setupValidation(this.validationRules());

        this.$watch('postalCode', (newValue) => {
            if(newValue.length === 0) {
                this.showBottledWater = false;
                this.dealers = [];
                this.dealer = '';
                return;
            }
            else if(newValue.length < 5) {
                return;
            }
            this.dealerError = false;
            this.searchDealers();
        });

        this.$watch('appointmentSet', (newValue) => {
            if (!newValue) {
                this.appointment = null;
            } 
            else if(this.appointment) {
                return;
            }
            else {
                let newDate = new Date();
                let year = newDate.getFullYear();
                let month = (newDate.getMonth() + 1).toString().padStart(2, '0');
                let date = newDate.getDate().toString().padStart(2, '0');
                let hour = newDate.getHours().toString().padStart(2, '0');
                let minute = newDate.getMinutes().toString().padStart(2, '0');
                this.appointment = year + '-' + month + '-' + date + 'T' + hour + ':' + minute;
            }
        });

        this.$watch('appointment', (newValue) => {
            if(!newValue) {
                this.appointmentSet = false;
            } 
            else {
                this.appointmentSet = true;
                this.appointment = newValue;
            }
        });

        this.$watch('phone', (newValue) => {
            this.phone = this.cleanPhone(newValue);
        });


    },

    cleanPhone(phoneVal) {

        //remove country code
        let phoneFirstTwo = phoneVal.substr(0, 2);
            if (phoneFirstTwo === "1-" || phoneFirstTwo === "+1" || phoneFirstTwo === "1+" || phoneFirstTwo === "1 ") {
                phoneVal = phoneVal.replace("1-", "").replace("1+", "").replace("+1", "").replace("1 ", "");
            }

            //remove non-digit characters
            phoneVal = phoneVal.replace(/\D/g, "");

            //format valid phone
            if (phoneVal.length === 10) {
                phoneVal = phoneVal.substr(0, 3) + "-" + phoneVal.substr(3, 3) + "-" + phoneVal.substr(6, 4);
            } 

            return phoneVal;
    },

    searchDealers() {

        //reset search state
        this.bottledWater = '';
        this.selectedDealer = null;
        this.dealers = [];

        //start search
        this.searching = true;

        //call to dealer locator api
        axios.get(apiRoute.concat('', '/api/v1/locator'), {
                params: {
                    pc: this.postalCode,
                },
            })
            .then(response => {

                //add the results to our available dealers
                this.dealers = response.data;

                //if we only get 1 dealer back, we'll autoselect it for the user
                if (this.dealers.length === 1) {
                    this.showBottledWater = false;
                    this.selectDealer(this.dealers[0]);
                }
                else if (this.dealers.length === 0) {
                    this.dealerError = true;
                    this.showBottledWater = false;
                    this.dealer = null;
                }
                else {
                    this.showBottledWater = true;
                    this.bottledWater = true;
                }
            })
            .catch(error => {
                console.log(error);
            })
            .then(() => {

                //
                this.searching = false;
                this.searched = true;
            });
    },

    showDealers(bottledWaterInterest) {
        this.showBottledWater = false;
        this.dealers = this.dealers.filter(dealer => !dealer[bottledWaterInterest ? 'services_exclusive' : 'services_inclusive'].includes('bottled_water'));
    },

    selectDealer(dealer) {
        this.dealer = dealer;
        this.dealers = [];
    },

    submitForm() {

        this.validateForm();
        
        if (this.validation.isValid()) {

            this.submitLead();
            this.formError = false;

            //disable default
            return false;
        }
        this.formError = true;
    },

    submitLead() {

        //only allow one submission at once
        if (this.submitStatus === 'in progress') {
            return;
        }

        //start submission
        this.submitStatus = 'in progress';

        //submit to API
        return axios.post(apiRoute.concat('', '/api/v1/leads'), {
                url_page: window.location.href,
                dealer_id: this.dealer['id'],
                force_id: this.dealer['culligan_corporate_id'],
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                street: this.street,
                city: this.city,
                postal_code: this.postalCode,
                phone: this.phone,
                message: this.comments,
                appointment_request: this.appointmentSet ? this.appointment.substring(0, this.appointment.indexOf("T")) : '',
                appointment_request_time: this.appointmentSet ? this.appointment.split('T')[1] : '',
                bottled_water: this.bottledWater,
                template: 'web',
            })
            .then(response => {
                this.submitStatus = 'success';
                this.submitMessage = 'Successfully submitted lead.';

                if (typeof window.formSubmitted === 'function') {
                    window.formSubmitted();
                }

                window.location.hash = 'success';
            })
            .catch(error => {
                this.submitStatus = 'failure';
                this.submitMessage = error.response.data.message ?? 'Unable to submit lead. Please try again.';
            });
    },

    validateForm() {

        if (!this.validation.isSetup()) {
            this.setupValidation(this.validationRules());
        }
        
        this.attemptSubmit = true;
        this.validation.validate();
    },

    resetForm() {

        //empty the data fields
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.street = '';
        this.city = '';
        this.postalCode = '';
        this.phone = '';
        this.appointmentSet = false;
        this.appointment = '';
        this.comments = '';
        this.bottledWater = false;
        this.dealers = [];
        this.dealer = null;
        this.attemptSubmit = false;

        this.formError = false;
        this.dealerError = false;
        this.phoneError = false;

        //reset the validation
        this.validation.reset();
        this.setupValidation(this.validationRules());
    },

    validationClass(field) {
        if (this.attemptSubmit) {
            return this.validation.isFieldValid(field) ? 'is-valid' : 'is-invalid';
        }

        return '';
    },

    showValidation(field) {
        return this.attemptSubmit && !this.validation.isFieldValid(field);
    },

    setupValidation(rules) {

        Object.entries(rules).forEach(([key, value]) => {

            //create validation entry
            this.validation.addField(key, value);

            //setup watcher
            this.$watch(key, (value) => {
                this.validation.updateData(key, value);
                this.validation.validateField(key);
            });
        });
    },

    validationRules() {

        return {
            firstName: [
                this.requiredFields.firstName ? 'required' : 'optional',
                'minLength:2',
                'maxLength:50',
            ],
            lastName: [
                this.requiredFields.lastName ? 'required' : 'optional',
                'minLength:2',
                'maxLength:50',
            ],
            street: [
                this.requiredFields.street ? 'required' : 'optional',
                'minLength:2',
                'maxLength:255',
            ],
            city: [
                this.requiredFields.city ? 'required' : 'optional',
                'minLength:2',
                'maxLength:255',
            ],
            postalCode: [
                this.requiredFields.postalCode ? 'required' : 'optional',
                'minLength:5',
                'maxLength:7',
            ],
            dealer: ['required'],
            phone: [
                this.requiredFields.phone ? 'required' : 'optional',
                'minLength:9',
                {
                    rule: 'regexMatch',
                    param: /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/,
                },
            ],
            email: [
                this.requiredFields.email ? 'required' : 'optional',
                'email',
            ],
            comments: [
                this.requiredFields.message ? 'required' : 'optional',
                'maxLength:500',
            ],
        };
    },

});
